import React, { useEffect, useState } from "react";

import { apiGet } from "../../Api/Client.js";
import { EmptyState, Panel } from "../../Shared/ScreenComponents.jsx";

function inr(n) {
  const v = Number(n) || 0;
  return `₹${Math.round(v).toLocaleString("en-IN")}`;
}

export function DevOpsScreen() {
  const [pack, setPack] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    apiGet("/FinanceAndPayroll/Transactions/subscription-register/")
      .then((res) => setPack(res))
      .catch((err) => setError(err?.message || "Could not load the register."));
  }, []);

  if (error) return <section style={{ padding: 28 }}><EmptyState label={error} /></section>;
  if (!pack) return <section style={{ padding: 28 }}><EmptyState label="Loading…" /></section>;

  const grants = pack.github_grants || {};
  return (
    <section style={{ padding: "24px 28px", display: "flex", flexDirection: "column", gap: 18 }}>
      <div>
        <span style={{ fontSize: 12, color: "var(--c-500)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.04em" }}>Development</span>
        <h1 style={{ margin: "4px 0 0", fontSize: 26, fontWeight: 700 }}>DevOps</h1>
        <div style={{ marginTop: 6, color: "var(--c-500)", fontSize: 13.5, maxWidth: 720 }}>
          The subscriptions the bank is already paying, taken from the P&amp;L. A row with no project is a hole: the charge is real, and nobody has said which product consumed it.
        </div>
      </div>

      <Panel title="Subscriptions" subtitle={`${pack.subscriptions.length} named from the statements. ${pack.unnamed} still have no vendor name.`}>
        <table className="Erp-Table" style={{ width: "100%" }}>
          <thead>
            <tr>
              <th style={{ textAlign: "left" }}>Vendor</th>
              <th style={{ textAlign: "left" }}>Kind</th>
              <th style={{ textAlign: "right" }}>Paid</th>
              <th style={{ textAlign: "right" }}>Charges</th>
              <th style={{ textAlign: "left" }}>Last charge</th>
              <th style={{ textAlign: "left" }}>Project</th>
            </tr>
          </thead>
          <tbody>
            {pack.subscriptions.map((row) => (
              <tr key={row.vendor}>
                <td>{row.vendor}</td>
                <td>{row.family}</td>
                <td style={{ textAlign: "right", fontVariantNumeric: "tabular-nums" }}>{inr(row.spend)}</td>
                <td style={{ textAlign: "right" }}>{row.charges}</td>
                <td>{row.last || ""}</td>
                <td style={{ color: "var(--c-500)" }}>Not mapped</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Panel>

      <Panel title="Access that is actually recorded" subtitle="GitHub grants on a project. API keys are not in this database.">
        <div style={{ display: "flex", gap: 18, flexWrap: "wrap", fontSize: 14 }}>
          {Object.keys(grants).length === 0 && <span>No active project assignments.</span>}
          {Object.entries(grants).map(([status, count]) => (
            <span key={status}><strong>{count}</strong> {status}</span>
          ))}
        </div>
      </Panel>

      <Panel title="What this page cannot see yet">
        <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.6 }}>
          {(pack.gaps || []).map((gap) => <li key={gap}>{gap}</li>)}
        </ul>
      </Panel>
    </section>
  );
}
